import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
// Import Modules
import cidade from './modules/cidades'
import auth from './modules/auth'
import acesso from './modules/acesso/'
import informacoes from './modules/informacoes'
import pedido from './modules/pedido/'
import pedidoPainelPromotor from './modules/pedido/painelPromotor'
import pedidoInss from './modules/pedido/inss'
import sincBanco from './modules/pedido/sincBanco'
import hiscon from './modules/consultas/hiscon'
import relacionados from './modules/consultas/relacionados'
import comissao from './modules/gerenciador/comissao'
import regras from './modules/gerenciador/regras'
import fornecedor from './modules/gerenciador/fornecedor'
import tipo from './modules/gerenciador/tipo'
import empresa from './modules/gerenciador/empresa'
import unidade from './modules/gerenciador/unidade'
import usuario from './modules/gerenciador/usuario'
import contrato from './modules/gerenciador/contrato'
import grupo from './modules/gerenciador/grupo'
import movimentacoes from './modules/gerenciador/movimentacoes'
import meta from './modules/meta'
import performance from './modules/performance'
import arquivo from './modules/arquivo'
import roteiro from './modules/gerenciador/roteiro'
import link from './modules/gerenciador/link'
import comunicado from './modules/gerenciador/comunicado'
import perfil from './modules/gerenciador/perfil'
import permissao from './modules/gerenciador/permissoes'
import listagem from './modules/listagem'
import configuracaoNegocios from './modules/gerenciador/configuracaoNegocios'
import avisos from './modules/gerenciador/avisos'
import leads from './modules/pedido/leads'
import vendedor from './modules/gerenciador/vendedor'
import pedidoSiape from './modules/pedido/siape'
import pedidoCadastral from './modules/pedido/cadastral'
import cobrancas from './modules/gerenciador/cobrancas'
import planosassinaturas from './modules/gerenciador/planosassinaturas'
import repassecomissao from './modules/adm_financeiro/repassecomissao'
import statusassinaturas from './modules/adm_financeiro/statusassinaturas'
import regrasbancos from './modules/gerenciador/regrasBancos'
import instituicoes from './modules/gerenciador/instituicoes'
import pedidoFGTS from './modules/pedido/fgts'
// Vue use Vuex
Vue.use(Vuex)

// Define Modulos
store.modules = {
  cidade,
  auth,
  acesso,
  pedido,
  pedidoPainelPromotor,
  pedidoInss,
  hiscon,
  relacionados,
  informacoes,
  comissao,
  regras,
  fornecedor,
  tipo,
  empresa,
  unidade,
  usuario,
  contrato,
  grupo,
  movimentacoes,
  meta,
  performance,
  arquivo,
  roteiro,
  link,
  comunicado,
  perfil,
  permissao,
  listagem,
  sincBanco,
  configuracaoNegocios,
  leads,
  avisos,
  vendedor,
  pedidoSiape,
  pedidoCadastral,
  pedidoFGTS,
  planosassinaturas,
  cobrancas,
  repassecomissao,
  statusassinaturas,
  regrasbancos,
  instituicoes
}

export default new Vuex.Store(store)



// WEBPACK FOOTER //
// ./src/store/index.js